import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import App from './App';
import { StylesProvider, createGenerateClassName } from '@material-ui/core/styles';

const generateClassName = createGenerateClassName({
  seed: 'uf'
});
export default class Root extends Component {

  render() {
    const { store, history } = this.props;    

    return (
      <StylesProvider generateClassName={generateClassName}>
        <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
        </Provider>
      </StylesProvider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};
